import script from "./AdminAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./AdminAnnouncements.vue?vue&type=style&index=0&id=fff4cc1c&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fff4cc1c"]])

export default __exports__